(() => {
  const copy = window.tenpmPrivacyCopy;
  if (!copy) return;

  const applyPrivacyCopy = () => {
    const policyLink = document.querySelector('#shopify-pc__banner__body-policy-link');
    const bannerParagraph = policyLink?.closest('p');

    if (bannerParagraph && bannerParagraph.dataset.tenpmCopyApplied !== 'true') {
      for (const node of [...bannerParagraph.childNodes]) {
        if (node !== policyLink) node.remove();
      }
      bannerParagraph.prepend(document.createTextNode(`${copy.bannerBody} `));
      bannerParagraph.dataset.tenpmCopyApplied = 'true';
    }

    const marketingDescription = document.querySelector('#shopify-pc__prefs__marketing > p');
    if (marketingDescription && marketingDescription.textContent !== copy.marketingDescription) {
      marketingDescription.textContent = copy.marketingDescription;
    }
  };

  applyPrivacyCopy();

  const observer = new MutationObserver(applyPrivacyCopy);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
